import React from 'react';
import PropTypes from 'prop-types';
import { Chip, Fab, Icon, makeStyles, Tooltip, Typography, useTheme } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { qualityClassColor } from '../../../../../helpers/manageColors';

const useStyles = makeStyles((theme) => ({
  chips_general: {
    margin: theme.spacing(1),
    textTransform: 'capitalize',
    height: '20px',
    margin: '2px 0',
    minWidth: '120px',
    borderRadius: '5px',
  },
}));

const QualityChips = ({
  chipIcon,
  evaluationClass,
  evaluationLabel,
  tooltipText,
  chipAction,
  extraStyles,
  tooltipAction,
  tooltipLeave,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const theme = useTheme();
  const qualityInRevision = useSelector((state) => state.labeling?.qualityInRevisionMode);

  return (
    <Tooltip title={<div>{tooltipText}</div>} placement='top' arrow>
      <Chip
        onMouseOver={tooltipAction || undefined}
        onMouseLeave={tooltipLeave || undefined}
        icon={chipIcon}
        label={
          <Typography style={{ paddingTop: '1px', fontSize: '0.8rem', lineHeight: '0.8rem' }}>
            {evaluationLabel}
          </Typography>
        }
        onClick={() => {
          if (chipAction && qualityInRevision) chipAction();
        }}
        variant='outlined'
        className={classes.chips_general}
        style={{
          border: `1px solid ${qualityClassColor(evaluationClass, theme)}20`,
          backgroundColor: `${qualityClassColor(evaluationClass, theme)}20`,
          color: qualityClassColor(evaluationClass, theme),
          fontSize: theme.fonts.responsiveMedium,
          cursor: qualityInRevision ? 'pointer' : 'help',
          ...extraStyles,
        }}
      />
    </Tooltip>
  );
};

QualityChips.propTypes = {
  chipIcon: PropTypes.element,
  evaluationClass: PropTypes.string,
  evaluationLabel: PropTypes.string,
  chipAction: PropTypes.func,
  tooltipText: PropTypes.node,
  extraStyles: PropTypes.object,
  tooltipLeave: PropTypes.func,
  tooltipAction: PropTypes.func,
};

QualityChips.defaultProps = {
  chipIcon: null,
  evaluationClass: '',
  evaluationLabel: '',
  chipAction: null,
  tooltipText: <Typography>''</Typography>,
  extraStyles: {},
  tooltipLeave: null,
  tooltipAction: null,
};

export default QualityChips;
